module.exports = __webpack_public_path__ + "img/warning.8ddf0541.png";